export default {
  strict: true,
  namespaced: true,
  state: {
    isAdd: false,
    add: {
    },
    showSelectUser: false,
    userCard: {
      list: [],
      loading: false
    },
    showSelectCorporate: false,
    corporateCard: {
      list: [],
      loading: false
    },
    isCorporate: false,
    addLoading: false,
    asap: {
      enable: false,
      show: false,
      loading: false,
      noDriver: false,
      foundDriver: false,
      driverInfoLoading: false,
      bidId: '',
      driverInfo: {
        fullName: '',
        email: '',
        rating: '',
        profilePic: '',
        vehiclePick: '',
        model: '',
        plate: ''
      }
    },
    submitError: {
      show: false,
      message: ''
    }
  },
  mutations: {
    asapReset (state) {
      state.asap = {
        enable: false,
        show: false,
        loading: false,
        noDriver: false,
        foundDriver: false,
        driverInfoLoading: false,
        bidId: '',
        driverInfo: {
          fullName: '',
          email: '',
          rating: '',
          profilePic: '',
          vehiclePick: '',
          model: '',
          plate: ''
        }
      }
    },
    setIsAdd (state, value) { state.isAdd = value },
    setShowSelectUser (state, value) { state.showSelectUser = value },
    setUserCardList (state, value) { state.userCard.list = value },
    setUserCardLoading (state, value) { state.userCard.loading = value },

    setShowSelectCorporate (state, value) { state.showSelectCorporate = value },
    setCorporateCardList (state, value) { state.corporateCard.list = value },
    setCorporateCardLoading (state, value) { state.corporateCard.loading = value },
    setIsCorporate (state, value) { state.isCorporate = value },

    setAddLoading (state, value) { state.addLoading = value },
    setAsapEnable (state, value) { state.asap.enable = value },
    setAsapShow (state, value) { state.asap.show = value },
    setAsapLoading (state, value) { state.asap.loading = value },
    setNoDriver (state, value) { state.asap.noDriver = value },
    setFoundDriver (state, value) { state.asap.foundDriver = value },
    setDriverInfoLoading (state, value) { state.asap.driverInfoLoading = value },
    setDriverInfo (state, value) { state.asap.driverInfoLoading = value },
    setAsapBidId (state, value) { state.asap.bidId = value },
    setSubmitError (state, data) {
      state.submitError = {
        show: data.show,
        message: data.message
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/add.js